import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Image from "react-bootstrap/Image";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Formik } from "formik";
import * as yup from "yup";
import Select, { StylesConfig } from "react-select";
import { mapMstToOptions } from "utils/HelperFunction";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ModalSuccessCustom from "layouts/ModalSuccessCustom";
import { useAppDispatch, useAppSelector } from "../redux/store/configureStore";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { getAllMstPrefix } from "../redux/handlers/master/getAllMstPrefix.handler";
import { login } from "../redux/handlers/auth/login.handler";
import { VER } from "constants/server/api";
import { LOGO_URL, SERVER_NAME } from "constants/server/config";
import { env } from "env";
import { clearRegister, register } from "../redux/handlers/auth/register.handler";
export function Register() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(false), 2), formdisabled = _useState[0], setFormdisabled = _useState[1];
    var _useState1 = _sliced_to_array(useState({
        visible: false,
        textsuccess: "",
        direction: ""
    }), 2), modalsuccess = _useState1[0], setModalsuccess = _useState1[1];
    var loadAllMsts = function() {
        dispatch(getAllMstPrefix());
    };
    var registerReducer = useAppSelector(function(state) {
        return state.registerReducer;
    });
    var getAllMstPrefixReducer = useAppSelector(function(state) {
        return state.getAllMstPrefixReducer;
    });
    var _useState2 = _sliced_to_array(useState([]), 2), optionsMstPrefix = _useState2[0], setOptionsMstPrefix = _useState2[1];
    useEffect(function() {
        loadAllMsts();
        localStorage.clear();
    }, []);
    useEffect(function() {
        setIsLoading(getAllMstPrefixReducer.isFetching);
        if (getAllMstPrefixReducer.data) {
            var options = mapMstToOptions(getAllMstPrefixReducer.data.data);
            setOptionsMstPrefix(_to_consumable_array(options));
        }
    }, [
        getAllMstPrefixReducer
    ]);
    var schema = yup.object().shape({
        prefix: yup.string().required("กรุณาเลือกคำนำหน้าชื่อ"),
        fname: yup.string().required("กรุณากรอกชื่อ"),
        lname: yup.string().required("กรุณากรอกนามสกุล"),
        phone: yup.number().typeError("กรุณากรอกเบอร์โทรให้ถูกต้อง").required("กรุณากรอกเบอร์โทร"),
        email: yup.string().email("กรุณากรอกอีเมลให้ถูกต้อง").required("กรุณากรอกอีเมล"),
        password: yup.string().required("กรุณากรอกรหัสผ่าน").min(8, "รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร"),
        confirmpassword: yup.string().required("กรุณากรอกยืนยันรหัสผ่าน").min(8, "รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร").oneOf([
            yup.ref("password"),
            null
        ], "รหัสผ่านไม่ตรงกัน")
    });
    var _useState3 = _sliced_to_array(useState("password"), 2), inputtype = _useState3[0], setInputtype = _useState3[1];
    var _useState4 = _sliced_to_array(useState({
        token: btoa(JSON.stringify({
            timestamp: Date.now(),
            random: Math.random()
        })),
        prefix: "",
        fname: "",
        lname: "",
        phone: "",
        email: "",
        password: "",
        confirmpassword: ""
    }), 2), formData = _useState4[0], setFormData = _useState4[1];
    var handleRegister = function(values) {
        dispatch(register(values, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    useEffect(function() {
        setIsLoading(registerReducer.isFetching);
        if (registerReducer.data && registerReducer.isError) {
            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                visible: true,
                subTitle: "เกิดข้อผิดพลาด",
                navigateDirection: undefined,
                title: registerReducer.data.message
            }));
            return;
        }
        if (registerReducer.data && !registerReducer.isError) {
            localStorage.setItem("registerToken", formData.token);
            localStorage.setItem("registerEmail", registerReducer.data.data.mb_mem_email);
            setModalsuccess(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    visible: true,
                    textsuccess: "บันทึกสำเร็จ กรุณาตรวจสอบอีเมลของคุณ",
                    direction: "/register/sendmail"
                });
            });
            setFormdisabled(true);
            dispatch(clearRegister());
        }
    }, [
        registerReducer
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "loginpage bg-white",
        children: [
            /*#__PURE__*/ _jsxs(Row, {
                className: "g-0",
                children: [
                    /*#__PURE__*/ _jsx(Col, {
                        lg: 7,
                        xl: 8,
                        className: "d-none d-xl-block",
                        children: /*#__PURE__*/ _jsx(Image, {
                            src: "/images/banner_login.png",
                            className: "w-100",
                            style: {
                                height: "100vh",
                                objectFit: "cover"
                            }
                        })
                    }),
                    /*#__PURE__*/ _jsx(Col, {
                        className: "d-flex justify-content-center align-items-center h-100vh",
                        children: /*#__PURE__*/ _jsx(Card, {
                            className: "box-login",
                            children: /*#__PURE__*/ _jsxs(Card.Body, {
                                className: "",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "fs-18 fw-500 mb-3 tc-1",
                                        children: "ข้อมูลส่วนตัว"
                                    }),
                                    /*#__PURE__*/ _jsx(Formik, {
                                        initialValues: formData,
                                        validationSchema: schema,
                                        onSubmit: handleRegister,
                                        children: function(param) {
                                            var handleSubmit = param.handleSubmit, handleChange = param.handleChange, touched = param.touched, isValid = param.isValid, errors = param.errors, values = param.values, setFieldValue = param.setFieldValue;
                                            return /*#__PURE__*/ _jsxs(Form, {
                                                noValidate: true,
                                                onSubmit: handleSubmit,
                                                children: [
                                                    /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-2 form-st-3 pb-1",
                                                        children: [
                                                            /*#__PURE__*/ _jsxs(Form.Label, {
                                                                className: "mb-1",
                                                                children: [
                                                                    "คำนำหน้าชื่อ ",
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        style: {
                                                                            color: "red"
                                                                        },
                                                                        children: "*"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsx(Select, {
                                                                as: "select",
                                                                name: "prefix",
                                                                onChange: function(e) {
                                                                    setFieldValue("prefix", e.value);
                                                                },
                                                                className: !!errors.prefix ? "w-100 select-st-1 isInvalid " : "w-100 select-st-1",
                                                                options: optionsMstPrefix,
                                                                placeholder: "เลือกคำนำหน้าชื่อ",
                                                                isInvalid: !!errors.prefix,
                                                                value: optionsMstPrefix.filter(function(item) {
                                                                    return item.value === values.prefix;
                                                                })
                                                            }),
                                                            errors.prefix && /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1 text-danger",
                                                                children: errors.prefix
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-2 form-st-3 pb-1",
                                                        children: [
                                                            /*#__PURE__*/ _jsxs(Form.Label, {
                                                                className: "mb-1",
                                                                children: [
                                                                    "ชื่อ ",
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        style: {
                                                                            color: "red"
                                                                        },
                                                                        children: "*"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                type: "text",
                                                                name: "fname",
                                                                placeholder: "กรอกชื่อ",
                                                                onChange: handleChange,
                                                                isValid: touched.fname && !errors.fname,
                                                                isInvalid: !!errors.fname,
                                                                className: "form-st-1"
                                                            }),
                                                            errors.fname && /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1 text-danger",
                                                                children: errors.fname
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-2 form-st-3 pb-1",
                                                        children: [
                                                            /*#__PURE__*/ _jsxs(Form.Label, {
                                                                className: "mb-1",
                                                                children: [
                                                                    "นามสกุล ",
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        style: {
                                                                            color: "red"
                                                                        },
                                                                        children: "*"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                type: "text",
                                                                name: "lname",
                                                                placeholder: "กรอกนามสกุล",
                                                                onChange: handleChange,
                                                                isValid: touched.lname && !errors.lname,
                                                                isInvalid: !!errors.lname,
                                                                className: "form-st-1"
                                                            }),
                                                            errors.lname && /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1 text-danger",
                                                                children: errors.lname
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-2 form-st-3 pb-1",
                                                        children: [
                                                            /*#__PURE__*/ _jsxs(Form.Label, {
                                                                className: "mb-1",
                                                                children: [
                                                                    "เบอร์โทร ",
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        style: {
                                                                            color: "red"
                                                                        },
                                                                        children: "*"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                type: "text",
                                                                name: "phone",
                                                                placeholder: "กรอกเบอร์โทร",
                                                                onChange: handleChange,
                                                                isValid: touched.phone && !errors.phone,
                                                                isInvalid: !!errors.phone,
                                                                className: "form-st-1 mb-3"
                                                            }),
                                                            errors.phone && /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1 text-danger",
                                                                children: errors.phone
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fs-18 fw-500 mb-3 tc-1",
                                                        children: "ข้อมูลการใช้งาน"
                                                    }),
                                                    /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-2 form-st-3 pb-1",
                                                        children: [
                                                            /*#__PURE__*/ _jsxs(Form.Label, {
                                                                className: "mb-1",
                                                                children: [
                                                                    "อีเมล ",
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        style: {
                                                                            color: "red"
                                                                        },
                                                                        children: "*"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                type: "text",
                                                                name: "email",
                                                                placeholder: "กรอกอีเมล",
                                                                onChange: handleChange,
                                                                isValid: touched.email && !errors.email,
                                                                isInvalid: !!errors.email,
                                                                className: "form-st-1",
                                                                disabled: false
                                                            }),
                                                            errors.email && /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1 text-danger",
                                                                children: errors.email
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-2 form-st-3 pb-1",
                                                        children: [
                                                            /*#__PURE__*/ _jsxs(Form.Label, {
                                                                className: "mb-1",
                                                                children: [
                                                                    "รหัสผ่าน ",
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        style: {
                                                                            color: "red"
                                                                        },
                                                                        children: "*"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "position-relat</Form.Label>ive",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                        type: inputtype,
                                                                        name: "password",
                                                                        placeholder: "กรอกรหัสผ่าน",
                                                                        onChange: handleChange,
                                                                        isValid: touched.password && !errors.password,
                                                                        isInvalid: !!errors.password,
                                                                        className: "form-st-1"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Button, {
                                                                        type: "button",
                                                                        className: "btn btn-change-type-password",
                                                                        onClick: function() {
                                                                            return inputtype == "password" ? setInputtype("text") : setInputtype("password");
                                                                        }
                                                                    })
                                                                ]
                                                            }),
                                                            errors.password && /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1 text-danger",
                                                                children: errors.password
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-2 form-st-3 pb-1",
                                                        children: [
                                                            /*#__PURE__*/ _jsxs(Form.Label, {
                                                                className: "mb-1",
                                                                children: [
                                                                    "ยืนยันรหัสผ่าน ",
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        style: {
                                                                            color: "red"
                                                                        },
                                                                        children: "*"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "position-relative",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                        type: inputtype,
                                                                        name: "confirmpassword",
                                                                        placeholder: "กรอกยืนยันรหัสผ่าน",
                                                                        onChange: handleChange,
                                                                        isValid: touched.confirmpassword && !errors.confirmpassword,
                                                                        isInvalid: !!errors.confirmpassword,
                                                                        className: "form-st-1 mb-3"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Button, {
                                                                        type: "button",
                                                                        className: "btn btn-change-type-password",
                                                                        onClick: function() {
                                                                            return inputtype == "password" ? setInputtype("text") : setInputtype("password");
                                                                        }
                                                                    })
                                                                ]
                                                            }),
                                                            errors.confirmpassword && /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1 text-danger",
                                                                children: errors.confirmpassword
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs(Col, {
                                                        className: "d-flex justify-content-center align-items-center",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Button, {
                                                                type: "button",
                                                                onClick: function() {
                                                                    return navigate("/login");
                                                                },
                                                                className: "btn-return w-40 mr-2",
                                                                children: "ย้อนกลับ"
                                                            }),
                                                            /*#__PURE__*/ _jsx(Button, {
                                                                type: "submit",
                                                                className: "btn-login w-40",
                                                                disabled: registerReducer.isFetching,
                                                                children: "ถัดไป"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            });
                                        }
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(ModalSuccessCustom, {
                show: modalsuccess.visible,
                onHide: function() {
                    return setModalsuccess(function(prev) {
                        return _object_spread_props(_object_spread({}, prev), {
                            visible: false
                        });
                    });
                },
                textsuccess: modalsuccess.textsuccess,
                navigate: navigate,
                direction: modalsuccess.direction
            })
        ]
    });
}
